import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, Box, Typography, IconButton,
} from '@mui/material';
import { Close, AutoAwesome } from '@mui/icons-material';
import TemplateCatalogGrid from './TemplateCatalogGrid';

var NAVY = '#173E4B';
var AMBER = '#fba92c';

// Start-from-Template gallery: the archetype catalog in a dialog. The catalog
// fetch + card grid + clone flow live in TemplateCatalogGrid (shared with the
// Templates module tab); this only supplies the dialog chrome and closes on a
// successful clone before the grid navigates to the new product.
export default function TemplateGalleryDialog(props) {
  var open = props.open;
  var onClose = props.onClose;

  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
        <AutoAwesome sx={{ color: AMBER }} />
        <Box sx={{ flexGrow: 1 }}>
          <Typography sx={{ fontSize: 18, fontWeight: 700, color: NAVY }}>Start from a template</Typography>
          <Typography sx={{ fontSize: 12.5, color: '#6B7280' }}>
            Pick an archetype to bootstrap a new product — packages, benefits and rating are pre-wired.
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small"><Close /></IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {open && <TemplateCatalogGrid onCloned={onClose} />}
      </DialogContent>
    </Dialog>
  );
}
